import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  closeBtn: {
    marginRight: '1.6rem',
  },
  actionButton: {
    padding: '0rem 2rem',
  },
  contentText: {
    // against common modal styles, but content is too big
    textAlign: 'left',
    fontSize: '1.6rem',
    '& b': {
      color: colors.neutral[900],
      marginRight: '0.5rem',
    },
  },
  validationBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: colors.red[600],
    backgroundColor: colors.red[100],
    padding: '1rem',
    borderRadius: '1rem',
    textAlign: 'left',
    maxWidth: '60rem',
    margin: '4rem auto 6rem',
    boxSizing: 'border-box',
  },
  validations: {
    marginTop: '1rem',
    marginBottom: 0,
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    paddingLeft: '3rem',
    textAlign: 'left',
    color: colors.neutral[900],
  },
  validationBlockTitle: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.red[600],
    textAlign: 'center',
    paddingBottom: '1rem',
    borderBottom: `0.1rem solid ${colors.red[300]}`,
  },
  statisticsList: {
    padding: '4rem 0 0',
    margin: '4rem auto 0',
    maxWidth: '60rem',
    listStyle: 'none',
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '2rem',
  },
  validStatistics: {
    marginBottom: '6rem',
  },
  statisticsItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    padding: '1.5rem 1rem',
    fontWeight: 700,
    borderRadius: '1rem',
    boxSizing: 'border-box',
    color: colors.neutral[900],
    backgroundColor: colors.blue[100],
  },
  statisticTitle: {
    textTransform: 'uppercase',
    fontSize: '1.4rem',
    lineHeight: '2rem',
  },
  statisticValue: {
    fontSize: '2.4rem',
    lineHeight: '3.2rem',
  },
  total: {
    backgroundColor: colors.green[100],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
